export default __webpack_public_path__ + "static/media/icon-password-reset-success.f98f2aa8.svg";